import Vue from 'vue'
import { mapMutations } from 'vuex'
import { Prop, Component } from 'vue-property-decorator'
import { LoadingBar } from '@appbase/components/loading'
import * as types from '@appbase/store/types'

@Component({
    components: { LoadingBar },

    methods: {
        ...mapMutations({
            setModal: types.MODAL_CURRENT
        })
    }
})
export default class ModalLayout extends Vue{
    @Prop({ type: String, default: '' }) title!: string
    @Prop({ type: Boolean, default: false }) loading!: boolean
    @Prop({ type: Boolean, default: false }) full!: boolean
    @Prop({ type: String }) loadingMessage!: string
    @Prop({ type: String, default: 'width: 800px; height: 400px;' }) mStyle!: string
    @Prop({ type: Boolean, default: false }) isEmit!: boolean
    @Prop({ type: Boolean, default: false }) noFooter!: boolean
    @Prop({ type: Boolean, default: false }) noHeader!: boolean

    setModal!:(modal: appbase.TModalInfo<any> | null) => void;

    onCloseClick() {
        this.$emit('close');  
        this.setModal(null);
    }
}